import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

function FooterCol({ title, links, extra }) {
  return (
    <div>
      <p className="font-display font-bold text-sm text-slate-900 uppercase tracking-wider">{title}</p>
      <ul className="mt-3 space-y-2">
        {links.map(([label, to]) => (
          <li key={label}>
            {to.startsWith("/#") ? (
              <a href={to} className="text-sm text-slate-500 hover:text-blue-600 transition-colors">{label}</a>
            ) : (
              <Link to={to} className="text-sm text-slate-500 hover:text-blue-600 transition-colors">{label}</Link>
            )}
          </li>
        ))}
        {extra && <li>{extra}</li>}
      </ul>
    </div>
  );
}

export function SiteFooter() {
  const openCookie = () => window.dispatchEvent(new Event("open-cookie-settings"));
  return (
    <footer className="border-t border-slate-100 bg-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-5 py-12 grid gap-8 sm:grid-cols-4">
        <div>
          <Logo className="h-10" />
          <p className="mt-3 text-sm text-slate-400 max-w-xs">Guide digitali per affitti brevi. Tutto ciò che i tuoi ospiti chiedono, in un unico link.</p>
        </div>
        <FooterCol title="Prodotto" links={[["Come funziona", "/#come-funziona"], ["Prezzi", "/#pricing"], ["FAQ", "/faq"]]} />
        <FooterCol title="Legale"
          links={[["Privacy Policy", "/privacy"], ["Termini di Servizio", "/termini"], ["Cookie Policy", "/cookie"]]}
          extra={<button onClick={openCookie} data-testid="footer-manage-cookies" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Gestisci cookie</button>} />
        <FooterCol title="Account" links={[["Accedi", "/login"], ["Registrati", "/signup"]]} />
      </div>
      <div className="border-t border-slate-100 py-6 text-center text-sm text-slate-400">© 2026 StayGuide — Guide digitali per affitti brevi</div>
    </footer>
  );
}
